/**
 * Camera Icon
 */

import type { IconProps } from '../../types';

export function CameraIcon({ 
  className, 
  size = 24, 
  color = 'currentColor',
  'aria-label': ariaLabel = 'Camera',
  ...props
}: IconProps) {
  return (
    <svg 
      className={className}
      width={size} 
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-label={ariaLabel}
      role="img"
      {...props}
    >
      <path d="M14.5 4h-5L7 7H4a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-3l-2.5-3z" />
      <circle cx="12" cy="13" r="3" />
    </svg>
  );
}
